import 'script-loader!../../../../../js/flexslider/jquery.noconflict.js';
import 'script-loader!../../../../../js/flexslider/jquery.easing.js';
import 'script-loader!../../../../../js/flexslider/jquery.fitvid.js';
import 'script-loader!../../../../../js/flexslider/froogaloop.js';
import 'script-loader!../../../../../js/flexslider/jquery.hoverIntent.js';
import '../../../../../js/flexslider/jquery.flexslider-min.js';